import React, { Component } from "react";
import { connect } from "react-redux";
import { Dimensions, Platform } from "react-native";
import EStyleSheet from "react-native-extended-stylesheet";

import {
  pickTheme,
  getSurveyQuestionnaire,
} from "state/modules/survey/selectors";
import { triggerDeepUpdate } from "state/modules/app/actions";

const isNative = Platform.OS !== "web";

class BaseEStyleSheetManager extends Component {
  theme = null;

  createTheme = () => {
    const { questionnaire, organization } = this.props;
    this.theme = pickTheme(questionnaire, organization);
    EStyleSheet.clearCache();
    this.updateTheme();
    this.props.triggerDeepUpdate();
  };

  updateTheme = () => {
    const { width, height } = Dimensions.get("window");
    const $theme = width > height ? "landscape" : "portrait";
    EStyleSheet.build({ $theme, ...this.props.globals, ...this.theme });
  };

  listener = () => this.updateTheme();

  componentDidMount = () => {
    this.createTheme();
    isNative && Dimensions.addEventListener("change", this.listener);
  };

  componentWillUnmount = () => {
    isNative && Dimensions.removeEventListener("change", this.listener);
  };

  componentDidUpdate = prevProps => {
    const { questionnaire, organization } = this.props;
    if (
      (questionnaire && prevProps.questionnaire !== questionnaire) ||
      (organization.id && prevProps.organization !== organization) ||
      (questionnaire === undefined && prevProps.questionnaire?.id)
    ) {
      this.createTheme();
    }
  };

  render = () => <></>;
}

const mapDispatchToProps = {
  triggerDeepUpdate,
};

const mapStateToProps = state => {
  const questionnaire = getSurveyQuestionnaire(state);
  const organization = state.organization;
  return { questionnaire, organization };
};

export const EStyleSheetManager = connect(
  mapStateToProps,
  mapDispatchToProps,
)(BaseEStyleSheetManager);
